<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/IN91/IN91.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">IN 9.1 座舱域控制器</div>
                <div class="detail-banner-desc">
                    IN9.1基于第四代平台 SA8295P；<br />
                    集成了多屏交互、3D 车模联动、车机互联、智能驾驶交互、智能生态应用等功能；<br />
                    设有 1 个支持 USB 音视频播放的 Type-A 接口，及 2 个可连接 Switch 游戏机、手机和 VR 眼镜的 Type-C 接口；<br />
                    可实现仪表、车载信息娱乐系统（IVI）、娱乐显示屏、泊车辅助等功能的集成。除基本的信息娱乐功能外，还集成了人脸识别和手势识别功能。
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>
                    <div class="detail-desc">
                        <div>
                            搭载高通第四代骁龙数字座舱平台
                        </div>
                        <div>
                            单颗芯片支持多操作系统（QNX/Android）
                        </div>
                        <div>
                            支持多达11个显示器，10路摄像头，2路模拟麦克风，6路数字麦克风，12个APA/UPA雷达
                        </div>
                        <div>
                            支持5路100M/1路1000M以太网，4路CAN(FD)， 2路LIN
                        </div>
                        <div>
                            支持USB 2.0/3.0, WiFi 6E, BT 5.3
                        </div>
                        <div>
                            支持全栈手机互联
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN91/IN91-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">5nm</div>
                                    <div class="k">制程</div>
                                </div>
                                
                                <div class="spec-item">
                                    <div class="v">3100 GFLOPS</div>
                                    <div class="k">GPU</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">30/50 TOPS</div>
                                    <div class="k">NPU</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">24G + 256G</div>
                                    <div class="k">存储</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Up to 11</div>
                                    <div class="k">显示屏</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">220/256K DMIPS</div>
                                    <div class="k">CPU</div>
                                </div>
                                
                                <div class="spec-item spec-item-last">
                                    <div class="v">1000 Base-T1 + 5*100 Base-T1</div>
                                    <div class="k">以太网</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Main BT: BT5.2、Vice BT: BT5.2 & BLE、WIFI6 & WIFI6E</div>
                                    <div class="k">蓝牙WIFI</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                </div>

                <!-- <div class="spec-row">
                    
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">1000 Base-T1 + 5*100 Base-T1</div>
                                    <div class="k">以太网</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Main BT: BT5.2、Vice BT: BT5.2 & BLE、WIFI6 & WIFI6E</div>
                                    <div class="k">蓝牙WIFI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN91/IN91-1.jpg" alt="200-1-02">
                    </div>
                    
                </div> -->

                

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: 'IN 9.1 座舱域控制器 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/IN91.html'
};

import { createApp } from 'vue';
import App from './IN91.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./IN91.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
